export const normalizeExportResponse = responseData => {
  if (Array.isArray(responseData)) {
    return { stores: responseData, groups: [] }
  }

  return {
    stores: responseData?.stores || [],
    groups: responseData?.groups || []
  }
}
